import React from "react";
import { toast } from "sonner";
import { api } from "../lib/api";
import { Button } from "./ui/button";
import { BellRing } from "lucide-react";

/** Admin: shows the automatic payment-reminder schedule and lets them send one now. */
export function PaymentReminders() {
    const [info, setInfo] = React.useState(null);
    const [busy, setBusy] = React.useState(false);
    const load = React.useCallback(() => { api.get("/admin/payment-reminders/preview").then(r => setInfo(r.data)).catch(() => {}); }, []);
    React.useEffect(() => { load(); }, [load]);

    async function sendNow() {
        if (!window.confirm(`Email a payment reminder now to ${info?.families_unpaid || 0} famil${info?.families_unpaid === 1 ? "y" : "ies"} with unpaid bills?`)) return;
        setBusy(true);
        try {
            const { data } = await api.post("/admin/payment-reminders/send-now");
            toast.success(`Sent ${data.sent} reminder${data.sent === 1 ? "" : "s"}${data.skipped ? ` · ${data.skipped} skipped (already reminded today)` : ""}`);
            load();
        } catch { toast.error("Couldn't send reminders"); } finally { setBusy(false); }
    }
    if (!info) return null;
    return (
        <div className="rounded-xl border border-border bg-white px-4 py-3 mb-4 flex items-center gap-3 flex-wrap text-sm" data-testid="payment-reminders">
            <BellRing className="w-4 h-4 text-primary" />
            <div className="flex-1 min-w-[220px]">
                <b>Automatic payment reminders</b> · {info.schedule}, to families with unpaid bills (due by the 7th).
                <div className="text-xs text-brand-stone" data-testid="payment-reminders-count">
                    {info.families_unpaid} famil{info.families_unpaid === 1 ? "y" : "ies"} currently unpaid
                    {info.last_sent ? ` · last sent ${new Date(info.last_sent.created_at).toLocaleDateString()}` : ""}
                </div>
            </div>
            <Button variant="outline" size="sm" onClick={sendNow} disabled={busy || !info.families_unpaid} data-testid="payment-reminders-send-now">
                {busy ? "Sending…" : "Send reminder now"}
            </Button>
        </div>
    );
}
